import './ClipboardButton.scss';

import { IconClipboardBlank } from '@hulu-react-style-components/icons';
import { Button as TrekLink } from '@hulu/react-style-components';
import { bem } from 'mission-control-common-components';

import Tooltip from '../Tooltip';

const [block] = bem('clipboard-button');

type Props = {
  copyText: () => Promise<void>;
  tooltipText: string;
};

const ClipboardButton = ({ copyText, tooltipText }: Props): React.JSX.Element | null => {
  return navigator.clipboard ? (
    <Tooltip id="clipboard-tooltip" message={tooltipText} shouldRenderInPortal={false}>
      <div data-testid="copy-to-clipboard" onClick={copyText} className={block()}>
        <TrekLink>
          <IconClipboardBlank />
        </TrekLink>
      </div>
    </Tooltip>
  ) : null;
};

export default ClipboardButton;
